<template>
  <div>
    <div
      v-if="videos && videos.length"
      class="py-10 py-md-13 py-lg-16 position-relative items"
    >
      <div
        class="
          white--text
          text-h4 text-md-h3 text-center
          font-weight-bold
          position-relative
        "
      >
        Vídeos
      </div>

      <LoadingWidget color="white" v-if="loading" />

      <v-container class="position-relative py-0">
        <transition name="fade">
          <div v-if="!loading && videos.length" class="mt-7">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-for="(item, itemKey) in videos"
                :key="itemKey"
              >
                <VideoCard v-bind="item" />
              </v-col>
            </v-row>
          </div>
        </transition>
        <div v-if="pagesLength > 1" class="mt-5">
          <v-pagination
            v-model="page"
            :length="pagesLength"
            :total-visible="totalVisibles"
            circle
          ></v-pagination>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import VideoCard from "../cards/VideoCard.vue";

const _config = {
  mod: "videos",
};

export default {
  data: () => ({
    loading: true,
    videos: [],
    totalItems: 0,
    itemsPerPage: 6,
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;
        return this.$router.push({ query });
      },
    },
    totalVisibles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 5;
        default:
          return 9;
      }
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    getVideos() {
      this.loading = true;
      const params = {
        returnTotalItems: 1,
        itemsPerPage: this.itemsPerPage,
      };
      if (this.page) params.page = this.page;
      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.videos = list.map(({ id, title, link }) => ({
              id,
              title,
              link,
            }));
            this.totalItems = totalItems;
            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  created() {
    this.getVideos();
  },
  watch: {
    page() {
      this.getVideos();
    },
  },

  components: {
    LoadingWidget,
    VideoCard,
  },
};
</script>

<style lang="scss">
.v-pagination__more {
  color: white !important;
}
.v-pagination button.v-pagination__item:hover:not(.v-pagination__item--active),
.v-pagination
  button.v-pagination__navigation:hover:not(.v-pagination__item--active) {
  background-color: #fdfdfdd0 !important;
}

.v-pagination__navigation,
.v-pagination__item {
  height: 35px !important;
  width: 35px !important;
  font-size: 12px;
  transition: all 0.18s ease !important;
}
</style>
<style lang="scss" scoped>
.items {
  background: url(../../assets/img/bg/videos.jpg);
  background-position: center;
  background-size: cover;

  &:before {
    background: radial-gradient(50% 50% at 50% 50%, #01619d 0%, #004586 100%);
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0.8;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }

  .slides {
    padding-left: 80px;
    padding-right: 80px;

    @media screen and (max-width: 600px) {
      padding-left: 40px;
      padding-right: 40px;
    }

    &-nav {
      height: 0;
      left: 0;
      margin-top: -24px;
      position: absolute;
      top: 50%;
      width: 100%;

      @media screen and (max-width: 600px) {
        margin-top: -18px;
      }

      &-item {
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        height: 48px;
        width: 48px;

        @media screen and (max-width: 600px) {
          height: 36px;
          width: 36px;
        }

        &.disabled {
          opacity: 0.2;
          background-color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
</style>
